/**
 * Конвертирует градусы в радианы
 * @param {Number} deg Угол в градусах
 * @returns {Number}
 */
export function degToRad(deg) {
  return deg * Math.PI / 180;
}
